// extracted by mini-css-extract-plugin
export var modal = "_fb-0";